import type { AdminEligibility, AdminKycStatus } from '../api/admin.api'

/** Receiving state shown on the user hero and overview, from the combined eligibility. */
export function receivingPresentation(eligibility: AdminEligibility): {
  label: string
  tone: 'success' | 'neutral' | 'awaiting'
} {
  if (eligibility.approved) return { label: 'Liberado para receber', tone: 'success' }
  if (eligibility.checks.link.status === 'failed')
    return { label: 'Conta Stripe não criada', tone: 'neutral' }
  return { label: 'Recebimento bloqueado', tone: 'awaiting' }
}

export const kycStatusLabels: Readonly<Record<AdminKycStatus, string>> = {
  verified: 'Verificada',
  pending_verification: 'Em análise',
  action_required: 'Ação necessária',
  rejected: 'Rejeitada',
}
